import StartLink from './component.styles'
export default StartLink
